import { render, staticRenderFns } from "./VariantQuantities.vue?vue&type=template&id=65327fed&scoped=true&"
import script from "./VariantQuantities.vue?vue&type=script&lang=js&"
export * from "./VariantQuantities.vue?vue&type=script&lang=js&"
import style0 from "./VariantQuantities.vue?vue&type=style&index=0&id=65327fed&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65327fed",
  null
  
)

export default component.exports